import Vip from './vip-progressive';
export default Vip;
